<template>

  <t-page>

    <t-dialog-duplicate dialog-id="modal-duplicate-environment" v-if="formDuplicateShow" :origin="formDuplicate.origin"
                        :path-server="currentPage.path" :form-error="formDuplicateError"
                        v-model="formDuplicate" :title="currentPage.singularTitle" @onSubmit="onDuplicated">

      <template #default="{status}">


        <t-input v-if="spotFolderResume !== null" v-model="spotFolderResume.enterprise" fixed label="Local"/>

        <t-input v-if="spotFolderResume !== null" v-model="spotFolderResume.division" fixed label="Divisão"/>

        <t-input-code-label spot-folder
                            :status="status"
                            @onResume="onResumeSpotFolder"
                            required
                            command="insert"
                            v-model="formDuplicate.spotFolderId"/>

        <t-input hide-label :status="status" v-model="formDuplicate.environmentId" hidden/>
        <t-input label="Nome do Ambiente" :status="status" :add-error="formDuplicateError.name"
                 v-model="formDuplicate.changeName" required/>

      </template>
    </t-dialog-duplicate>

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage"
                 :breadcrumb="breadcrumb">

      <template #search>

        <div v-if="!enableDeleteBulk">

          <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                    :to="currentPage.name + '-form-new'"
                    class="mr-2"
                    primary/>

          <t-dropdown
              v-if="userAuth.validation.validationDelete"
              class="mr-2"
              variant="outline-primary" icon-settings>

            <template #button-content>
              <b-icon icon="gear-fill" aria-hidden="true"></b-icon>
              Ações
            </template>

            <b-dropdown-item @click="enableDeleteBulk = true"
                             v-if="userAuth.validation.validationDelete">Exclusão em Massa
            </b-dropdown-item>


          </t-dropdown>

        </div>


        <div v-else>

          <t-button :disabled="environmentIds.length === 0"
                    :text="'Excluir Ambientes selecionados ('+environmentIds.length+')'"
                    @click="onDeleteBulk"
                    class="mr-2"
                    danger/>

          <t-button outline-light @click="onCancelDeleteBulk" class="mr-2">Cancelar</t-button>

        </div>


        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :fields-custom="entityFieldCustomized('page')"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form">


          <b-row>

            <t-input-code-label enterprise
                                v-model="form.enterpriseId"/>

          </b-row>
          <b-row>


            <t-input-code-label spot-folder
                                v-model="form.spotFolderId"/>


          </b-row>

          <b-row>

            <t-input-search v-model="form.lastChecklistEnvironmentFinishDate" enable-range date
                            label="Data Última Inspeção"/>

          </b-row>

          <b-row>

            <t-input-search v-model="form.hasOccurrencePending" :options="yesOrNotOptions"
                            label="Possui apontamento pendente?" boolean/>

          </b-row>

          <b-row>

            <t-input-search v-model="form.sharingEnable" :options="yesOrNotOptions" boolean
                            label="Compartilhamento URL habilitado"/>

          </b-row>


        </t-content-header-search-default>

      </template>


      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :enable-checked="enableDeleteBulk"
               v-model="environmentIds"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="userAuth.viewFields"
               primary-key-array-ids="environmentId"
               primary-key-column="environmentNumber" link-primary-column="environmentCodeLabel">


        <template #item(qtyOccurrencePending)="{item}">

          <b-button v-if="item.qtyOccurrencePending > 0"
                    :to="{path: '/checklist/occurrence?environmentId='+item.environmentId+'&hasOccurrencePending=true'}"
                    variant="outline-primary" size="sm" target="_blank">
            <b-icon-box-arrow-up-right class="mr-2"/>
            Apontamentos
            <b-badge variant="warning">{{ item.qtyOccurrencePending }}</b-badge>
          </b-button>

          <small v-else>Não possui pendentes</small>

        </template>

        <template #item(lastChecklistEnvironmentFinishDate)="{item}">

          <b-button v-if="objValid(item.lastChecklistEnvironmentFinishDate)"
                    :to="{path: '/checklist/'+item.lastChecklistNumber}"
                    variant="outline-primary" size="sm" target="_blank">
            <b-icon-box-arrow-up-right class="mr-2"/>
            {{ item.lastChecklistEnvironmentFinishDate | date }}
          </b-button>

          <small v-else>Nunca inspecionado</small>

        </template>

        <template #append-actions="{item}">
          <b-button @click="openDialogDuplicate(item.spotFolderId, item.environmentId, item.name)"
                    class="opacity-6-hover"
                    v-if="userAuth.validation.validationCreate" size="sm" variant="outline" v-b-tooltip.hover.ds500
                    title="Duplicar Ambiente">
            <b-icon-files variant="primary"/>
          </b-button>
        </template>

      </t-table>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import TDialogDuplicate from "@/components/template/dialog/t-dialog-duplicate";
import ui from "@/assets/scripts/ui";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  components: {TDialogDuplicate},
  name: 'Environment',
  data() {
    return {
      enableGeneralFields: false,
      form: {
        enterpriseId: 0,
        spotFolderId: 0,
        lastChecklistEnvironmentFinishDate: "",
        hasOccurrencePending: null,
        sharingEnable: null,
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      environmentIds: [],
      enableDeleteBulk: false,
      formDuplicateShow: false,
      formDuplicate: {
        environmentId: 0,
        spotFolderId: 0,
        changeName: "",
        origin: "",
      },
      formDuplicateError: {
        name: "",
      },
      spotFolderResume: null,
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      this.breadcrumb = [
        //{text: 'Configurações', to: {name: 'production-setting'}},
      ]

    },
    async mountedContinued() {


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    onResumeSpotFolder(resume) {
      this.spotFolderResume = resume
    },
    openDialogDuplicate(spotFolderId, environmentId, origin) {

      this.formDuplicateShow = true
      this.formDuplicate.spotFolderId = spotFolderId
      this.formDuplicate.environmentId = environmentId
      this.formDuplicate.changeName = origin
      this.formDuplicate.origin = origin

      this.openDialogForm('modal-duplicate-environment')

    },

    onDuplicated(item) {

      this.formDuplicate.changeName = ""

      ui.toast(this, "Duplicado", "Novo ambiente <b>" + item.name + "</b> duplicado com sucesso!", "success", "b-toaster-top-center", true)

      this.getPage(this.pageNumber)

    },
    onCancelDeleteBulk() {
      this.environmentIds = []
      this.enableDeleteBulk = false
    },
    async onDeleteBulk() {


      await this.executeDeleteByBulk(this.environmentIds,
          "Deseja realizar a exclusão em massa do(s) <b>" + this.environmentIds.length + "</b> ambiente(s) selecionado(s)?",
          async () => {
            ui.toast(this, "Exclusão", "Exclusão em massa realizada com sucesso!", "success", "b-toaster-top-center", true)
            this.onCancelDeleteBulk()
            await this.getPage(this.pageNumber);
          },
          async () => {
            this.onCancelDeleteBulk()
            await this.getPage(this.pageNumber);
          }
      )

    },
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>

